document.addEventListener('DOMContentLoaded', function () {
  // Target wrapper by class instead of ID
  const section = document.querySelector('.pm-0002-scientific-insights-section-wrapper');
  if (!section) return;

  const tracker = section.querySelector('.pm-0002-scientific-insights-reading-tracker');
  const fillBar = section.querySelector('.pm-0002-scientific-insights-reading-fill');
  const labelsContainer = section.querySelector('.pm-0002-scientific-insights-reading-labels');
  const headings = section.querySelectorAll('.pm-0002-scientific-insights-content-subheading');
  if (!tracker || !fillBar || !labelsContainer || !headings.length) return;
  
  // Update Progress Bar
  function updateProgressBar() {
    const scrollY = window.scrollY;
    const viewportHeight = window.innerHeight;
    const firstHeading = headings[0];
    const lastHeading = headings[headings.length - 1];

    const start = firstHeading.getBoundingClientRect().top + scrollY - viewportHeight * 0.5;
    const end = lastHeading.getBoundingClientRect().top + scrollY + lastHeading.offsetHeight;
    const total = end - start;

    let progress = ((scrollY - start) / total) * 100;
    progress = Math.max(0, Math.min(progress, 100));
    fillBar.style.width = progress + '%';
  }

  // Create Labels
  function createReadingLabels() {
    labelsContainer.innerHTML = '';
    headings.forEach((heading) => {
      const label = document.createElement('span');
      label.textContent = heading.textContent.trim();
      label.classList.add('pm-0002-scientific-insights-reading-label-item');
      label.addEventListener('click', () => {
        const offset = heading.getBoundingClientRect().top + window.scrollY - tracker.offsetHeight;
        window.scrollTo({ top: offset, behavior: 'smooth' });
      });
      labelsContainer.appendChild(label);
    });
  }

  // Highlight Active Label
  function highlightActiveLabel() {
  const labels = labelsContainer.querySelectorAll('.pm-0002-scientific-insights-reading-label-item');
  let maxVisibleHeight = 0;
  let activeIndex = -1;

  headings.forEach((heading, index) => {
    const rect = heading.getBoundingClientRect();
    const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
    
    if (visibleHeight > maxVisibleHeight) {
      maxVisibleHeight = visibleHeight;
      activeIndex = index;
    }
  });

  labels.forEach((label, index) => {
    const isActive = index === activeIndex;
    label.classList.toggle('active', isActive);

    if (isActive) {
      const parent = labelsContainer;
      const scrollLeft = label.offsetLeft - parent.clientWidth / 2 + label.clientWidth / 2;
      parent.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    }
  });
}


  // Scroll + Resize Events
  function onScrollOrResize() {
    updateProgressBar();
    highlightActiveLabel();
  }

  window.addEventListener('scroll', onScrollOrResize);
  window.addEventListener('resize', onScrollOrResize);

  // Init
  createReadingLabels();
  onScrollOrResize();
});

document.addEventListener('DOMContentLoaded', function () {
  trackerView();
});

function trackerView() {
  
  function logWrapperVisibility() {
    const wrapper = document.querySelector('.pm-0002-scientific-insights-section-wrapper');
    const header = document.querySelector('.pm-0002-scientific-insights-reading-tracker');

    if (!wrapper) {
      return;
    }

    const rect = wrapper.getBoundingClientRect();
    const inViewport = (rect.top + 700) < window.innerHeight && rect.bottom > 0;

    if (inViewport) {
      header.classList.add("is-sticky");
    } else {
      
      header.classList.remove("is-sticky")
    }
  }

  // Run on scroll & resize
  window.addEventListener('scroll', logWrapperVisibility);
  window.addEventListener('resize', logWrapperVisibility);

  // Initial check
  logWrapperVisibility();
}